// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"tabStyles-module--tabContent--V3XNA","tabsContainer":"tabStyles-module--tabsContainer--1NxxV"};